//import CompLayout from "@/pcomponents/comp/layout/layout";
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDark } from '@/store/dark/dark';
import Header from "./header";
import Footer from "./footer";
import SNBArea from "./menu/snb";
import ContentTitle from "./content/con_title";

const StuLayout=(props:any)=>{
  let myProps:any={
    "isSubMenuArea":true,
    "isConTitle":false,
    "isFooter":false,
    ...props
  };
  const dispatch = useDispatch();
  let dark=useSelector((state:any) => state.dark);
  let dark_class_name="light";
  if(localStorage.theme=="dark"){
    dark_class_name=localStorage.theme;
  }

  useEffect(()=>{
    setDarkClass();
  },[dark]);

  const setDarkClass=()=>{
    if(dark.dark==""){
      if(localStorage.theme === 'dark' ){
        dispatch(setDark("dark"));
      }else{
        dispatch(setDark("light"));
      }
    }
  };

  return (
    <div id="main_wrap" className={dark_class_name} >
      <div className="main_body">
        <Header></Header>
        {(myProps.isSubMenuArea)&&
          <SNBArea></SNBArea>
        }
        <div id="stu_container">
          <div className="container_con">
            {myProps.isConTitle &&
              <ContentTitle></ContentTitle>
            }
            {myProps.children}
          </div>
        </div>
        {myProps.isFooter&&
          <Footer></Footer>
        }
      </div>
    </div>
  );
};

export default StuLayout;